












import Vue from 'vue'
import {
  GET_DISPOSITION_JOB_IS_STATUS,
  GET_DISPOSITION_JOB_STATUS_LIST
} from '@/store/getter-types'
import { SET_IS_DISPOSITION_JOB_STATUS } from '@/store/action-types'
import { mapGetters } from 'vuex'

interface ComponentData {
  items: any[]
  selectedItem: number | null
  oldValue: number | null
  isStatus: boolean
}

export default Vue.extend({
  name: 'ReplacementSelectCellRenderer',

  data (): ComponentData {
    return {
      items: [],
      selectedItem: null,
      oldValue: null,
      isStatus: false
    }
  },

  watch: {
    [GET_DISPOSITION_JOB_IS_STATUS] (newVal: boolean): void {
      this.isStatus = newVal
    }
  },

  computed: {
    ...mapGetters([GET_DISPOSITION_JOB_IS_STATUS]),

    getItems (): any[] {
      if(this.isStatus) {
        if(this.selectedItem != 5) {
          return this.items.filter((item: any) => item.id !== 5)
        } else {
          return this.items
        }
      } else {
        return this.items
      }
    }
  },

  methods: {
    onValueChange(value: number): void {
      // @ts-ignore
      this.params.data.status = value

      if(this.oldValue === 5 && value !== 5) {
        this.$store.dispatch(SET_IS_DISPOSITION_JOB_STATUS, false)
      } else if(value === 5) {
        this.$store.dispatch(SET_IS_DISPOSITION_JOB_STATUS, true)
      }

      this.oldValue = value
    }
  },

  mounted () {
    // @ts-ignore
    if(this.params.data.status) {
      // @ts-ignore
      this.selectedItem = this.params.data.status
      // @ts-ignore
      this.oldValue = this.params.data.status

      if(this.selectedItem === 5) {
        this.$store.dispatch(SET_IS_DISPOSITION_JOB_STATUS, true)
      }
    }
    this.isStatus = this.$store.getters[GET_DISPOSITION_JOB_IS_STATUS]
    this.items = this.$store.getters[GET_DISPOSITION_JOB_STATUS_LIST]
  }
})
